import { isSingletonStringUnion } from "generic-type-guard";

import { ConsoleLoggingStrategy, LoggerFactory, Settings } from "@com.mgmtp.a12.utils/utils-logging";
import { LogLevel } from "@com.mgmtp.a12.utils/utils-logging/api";

export const logger = LoggerFactory.getLogger("modulf-editor");

type LogLevelName = keyof typeof LogLevel;
const isLogLevelName = isSingletonStringUnion("TRACE", "INFO", "LOG", "WARN", "ERROR");

class DynamicConsoleLoggingStrategy extends ConsoleLoggingStrategy {
	private static LocalStorageKey = "logLevel";
	private static DefaultLogLevel: LogLevelName = "WARN";

	constructor() {
		const logLevelName = DynamicConsoleLoggingStrategy.getLogLevelName();
		super(console, LogLevel[logLevelName]);
		// eslint-disable-next-line no-console
		console.info(`%cLog levels was set to ${logLevelName.toLowerCase()}.`, "font-weight: bold");
	}

	protected static getLogLevelName(): LogLevelName {
		const value = localStorage.getItem(DynamicConsoleLoggingStrategy.LocalStorageKey) ?? undefined;
		const logLevelName = value?.toUpperCase();
		return isLogLevelName(logLevelName) ? logLevelName : DynamicConsoleLoggingStrategy.DefaultLogLevel;
	}

	protected updateLogLevel(): void {
		const logLevelName = DynamicConsoleLoggingStrategy.getLogLevelName();
		const logLevel = LogLevel[logLevelName];

		if (this.logLevel !== logLevel) {
			this.logLevel = logLevel;
			// eslint-disable-next-line no-console
			console.info(`%cLog levels was set to ${logLevelName.toLowerCase()}.`, "font-weight: bold");
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	override digest(namespace: string, level: LogLevel, date: Date, message?: any, ...optionalParams: any[]): void {
		this.updateLogLevel();
		super.digest(namespace, level, date, message, ...optionalParams);
	}
}

Settings.LogStrategy = new DynamicConsoleLoggingStrategy();
